import { Injector } from '@angular/core';
import { getModelId, matchContextGroups } from '@core/shared/model';
import { ConfigService } from '@core/shared/config';
import { Store } from '@ngxs/store';
import { convertToSubject } from '@core/shared/utils';
import { BehaviorSubject, combineLatest, forkJoin, map, of, switchMap } from 'rxjs';
import { DevToolsRegistry } from '../dev-tools';
import { FeatureService } from '../feature';
import { sharedInjectorForFrontend } from '../providers';
import * as i0 from "@angular/core";
import * as i1 from "../dev-tools";
import * as i2 from "@core/shared/config";
import * as i3 from "@ngxs/store";
import * as i4 from "../feature";
/**
 * model columns can be registered through FeatureDefinitions or by injecting ModelColumnService and using the registerColumn method.
 */
export let ModelColumnService = /*#__PURE__*/(() => {
  class ModelColumnService {
    constructor(debug, config, store, feature, injector) {
      this.store = store;
      this.injector = injector;
      this.customColumns$ = new BehaviorSubject([]);
      this.platform = config.getPlatform();
      this.featureBasedColumns$ = feature.getLoadedFeatures().pipe(map(features => {
        return features.reduce((allCols, f) => {
          const columns = f.getFeatureFunctionalityCached().modelColumns;
          if (columns) allCols.push(...columns);
          return allCols;
        }, []);
      }), convertToSubject());
      debug.exposeDebugFunction(['Model', 'Inspect ModelColumns'], () => {
        return combineLatest({
          featureBased: this.featureBasedColumns$,
          custom: this.customColumns$
        });
      });
    }
    registerColumn(column) {
      this.customColumns$.next([...this.customColumns$.value, column]);
    }
    getUnfilteredColumnsForModelId(modelIdInput) {
      const id = getModelId(modelIdInput);
      return combineLatest({
        featureBased: this.featureBasedColumns$,
        custom: this.customColumns$
      }).pipe(map(({
        featureBased,
        custom
      }) => {
        const all = [...featureBased, ...custom];
        return all.filter(action => {
          return action.modelId === id;
        });
      }));
    }
    getModelColumns(modelId, customGroups = [], staticDefinitions) {
      const currentContext = [this.platform, ...customGroups];
      const activeModelCols$ = this.getUnfilteredColumnsForModelId(modelId).pipe(
      // take(1),
      map(columns => {
        const modelColumnsWithMatchingGroups = columns.filter(columnClass => {
          return matchContextGroups(currentContext, columnClass.displayContext);
        });
        return modelColumnsWithMatchingGroups;
      }), switchMap(columns => {
        const observableConfigsList = columns.map(colClass => {
          return colClass.getConfigCached$(sharedInjectorForFrontend(this.injector));
        });
        const definitions$ = observableConfigsList.length > 0 ? forkJoin(observableConfigsList) : of([]);
        // console.log('colClasses mapped to observables',columns, observableConfigsList, definitions$)
        return definitions$.pipe(map(definitions => {
          // console.log('fetched definitions',definitions)
          if (staticDefinitions) return [...staticDefinitions, ...definitions];else return definitions;
        }));
      }));
      return activeModelCols$;
    }
    static {
      this.ɵfac = function ModelColumnService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ModelColumnService)(i0.ɵɵinject(i1.DevToolsRegistry), i0.ɵɵinject(i2.ConfigService), i0.ɵɵinject(i3.Store), i0.ɵɵinject(i4.FeatureService), i0.ɵɵinject(i0.Injector));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: ModelColumnService,
        factory: ModelColumnService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ModelColumnService;
})();